// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"Subscribe_subscribe__2ROat","logo":"Subscribe_logo__5tAVL"};